module.exports = __webpack_public_path__ + "static/img/teamHonorBg5.85a6a100.png";